module.exports = __webpack_public_path__ + "static/media/mumbai.3fece353.jpg";